Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingName1487631630",
  {"root":"OfferingName1487631630--root","link":"OfferingName1487631630--link","offeringName":"OfferingName1487631630--offeringName"},
  "",
  2,
  "OfferingName1487631630"
);

